import { Axios } from "axios"
import { useAbortController } from "@/composables/useAbortController"
import { getAuthenticationStore, getCommonStore } from "@/helpers/storeHelpers"

export const AxiosInterceptorsRequest = (MyAxios: Axios): Axios => {
    MyAxios.interceptors.request.use((config) => {
        const authStore = getAuthenticationStore()
        const commonStore = getCommonStore()
        const abortController = useAbortController()
        if (authStore) {
            config.baseURL = authStore.customerSpaceUrl;
            config.headers.Authorization = authStore.access_token ? `Bearer ${authStore.access_token}` : undefined;
        }
        if (commonStore) {
            config.timeout = !commonStore.internetOnline ? 5000 : 60000;

            // spinning start to show
            if (!config.ignoreGlobalLoader && commonStore.internetOnline) {
                commonStore.startLoading(false, true);
                commonStore.requestLoading = true;
            }
        }

        return {
            ...config,
            signal: abortController.getSignal()
        };
    }, (error) => {
        return Promise.reject(error);
    });
    return MyAxios;
}